import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IToast } from './interfaces'

export const initialState = {
  baseUrl: '',
  programId: -1,
  toasts: [] as IToast[],
  successful: false,
  loadedViaCode: false,
  isRestoredData: false,
}

const misc = createSlice({
  name: 'process',
  initialState,
  reducers: {
    setData(state, action) {
      state.baseUrl = action.payload.baseUrl
      state.programId = action.payload.programId
    },
    addToast(state, action: PayloadAction<IToast>) {
      if(state.toasts.find((t) => t.body === action.payload.body)) {
        console.log("Already have a toast with the same text visible, skipping!")
      }else {
        state.toasts.push(action.payload)
      }
    },
    removeToast(state, action: PayloadAction<number>) {
      state.toasts.splice(action.payload, 1)
    },
    setSuccessful(state, action) {
      state.successful = action.payload
    },
    setLoadedViaCode(state, action) {
      state.loadedViaCode = action.payload
    },
  },
})

export const {
  setData,
  addToast,
  removeToast,
  setSuccessful,
  setLoadedViaCode,
} = misc.actions
export default misc.reducer
